const common_url = "https://node.firehrm.com/BYM/";
// const common_url = "http://localhost:9876/";

export default common_url;
